import { render } from "./PostMenu.vue?vue&type=template&id=17454370&scoped=true"
import script from "./PostMenu.vue?vue&type=script&lang=js"
export * from "./PostMenu.vue?vue&type=script&lang=js"

import "./PostMenu.vue?vue&type=style&index=0&id=17454370&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17454370"]])

export default __exports__